import { c as _c } from "react/compiler-runtime";
import { useCustomToasts } from '@systemeio/ui';
import { useSessionStore } from '@systemeio/util';
import { useEffect } from 'react';
import { getEmailRestrictLink } from 'shared/components/dashboard-mail-editor/utils/get-email-restrict-link';
import TransLoco from 'shared/components/trans-loco';
import { pageRoute } from 'shared/constants/routes.constants';
import { MailingStatusEnum } from 'shared/enums/mailing-status-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useSwrEmailStatusNotification } from 'shared/notifications/hooks/use-swr-email-status-notification';
import { getBlankLinkComponent } from 'shared/utils/get-blank-link-component';
import { getContactSupportLink } from 'shared/utils/get-contact-support-link';
import { useRouter } from 'shared/hooks/use-router';
const notificationClosedKey = (page: string) => `emailStatusNotificationClosed:${page}`;
const shouldShowNotificationForPath = (pathname: string) => {
  if (pathname === pageRoute.Dashboard) return pathname;
  const sectionsRoutes = ['/email-statistics', '/newsletters', '/campaigns', '/mailing'] as const;
  return sectionsRoutes.find(route => pathname.includes(route));
};
export const useEmailStatusNotification = () => {
  const $ = _c(21);
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const {
    user,
    isWorkspaceOwner
  } = useUser();
  const {
    infoToast
  } = useCustomToasts();
  let pageOrSection;
  let t0;
  if ($[0] !== pathname) {
    pageOrSection = shouldShowNotificationForPath(pathname);
    t0 = pageOrSection && notificationClosedKey(pageOrSection);
    $[0] = pathname;
    $[1] = pageOrSection;
    $[2] = t0;
  } else {
    pageOrSection = $[1];
    t0 = $[2];
  }
  const notificationStateKey = t0;
  const notificationState = useSessionStore(notificationStateKey ?? "");
  let t1;
  if ($[3] !== notificationState) {
    t1 = notificationState.getItem();
    $[3] = notificationState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const isClosed = t1 === true;
  const shouldFetchStatus = Boolean(pageOrSection && isWorkspaceOwner && !isClosed);
  const {
    data: status
  } = useSwrEmailStatusNotification(shouldFetchStatus);
  let t2;
  if ($[5] !== infoToast || $[6] !== isClosed || $[7] !== isWorkspaceOwner || $[8] !== notificationState || $[9] !== pageOrSection || $[10] !== status || $[11] !== t || $[12] !== user) {
    t2 = () => {
      if (!user) {
        return;
      }
      if (!pageOrSection) {
        return;
      }
      if (!isWorkspaceOwner) {
        return;
      }
      if (!status) {
        return;
      }
      if (isClosed) {
        return;
      }
      const options = {
        className: "lg:min-w-[600px]",
        duration: Infinity
      };
      const closeNotification = () => notificationState.setItem(true);
      bb35: switch (status.mailingStatus) {
        case MailingStatusEnum.pending:
          {
            infoToast(<TransLoco t={t} i18nKey="dashboard.notifications.email_status.pending" components={{
              a: getBlankLinkComponent(getEmailRestrictLink(user.dashboardLocale))
            }} />, options, closeNotification);
            break bb35;
          }
        case MailingStatusEnum.new_pending:
          {
            infoToast(<TransLoco t={t} i18nKey="dashboard.notifications.email_status.new_user" components={{
              a: getBlankLinkComponent(getEmailRestrictLink(user.dashboardLocale))
            }} />, options, closeNotification);
            break bb35;
          }
        case MailingStatusEnum.blocked:
          {
            infoToast(<TransLoco t={t} i18nKey="dashboard.notifications.email_status.blocked" components={{
              a: getBlankLinkComponent(getContactSupportLink(user.dashboardLocale))
            }} />, options, closeNotification);
            break bb35;
          }
        default:
          {
            return;
          }
      }
    };
    $[5] = infoToast;
    $[6] = isClosed;
    $[7] = isWorkspaceOwner;
    $[8] = notificationState;
    $[9] = pageOrSection;
    $[10] = status;
    $[11] = t;
    $[12] = user;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== isClosed || $[15] !== isWorkspaceOwner || $[16] !== notificationState.setItem || $[17] !== pageOrSection || $[18] !== status || $[19] !== user) {
    t3 = [user, pageOrSection, isWorkspaceOwner, status, notificationState.setItem, isClosed];
    $[14] = isClosed;
    $[15] = isWorkspaceOwner;
    $[16] = notificationState.setItem;
    $[17] = pageOrSection;
    $[18] = status;
    $[19] = user;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  useEffect(t2, t3);
};